'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, Fragment } from 'react';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import { omit } from 'underscore';
import { compose } from 'redux';
import Draggable from 'UIComponents/draggable/utils/Draggable';
import { FINDER_FOLDER_RENAME } from 'DesignData/actions/ActionTypes';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import AssetContextMenu from 'DesignFinderUI/components/menus/AssetContextMenu';
import FolderNavItemLink from 'DesignFinderUI/components/nav/FolderNavItemLink';
import RenameFolderConfirmModal from 'DesignFinderUI/components/modals/RenameFolderConfirmModal';
import withNewFileWizard from 'DesignFinderUI/components/modals/hoc/withNewFileWizard';
import withNewThemeWizard from 'DesignFinderUI/components/modals/hoc/withNewThemeWizard';
import withNewFunctionWizard from 'DesignFinderUI/components/modals/hoc/withNewFunctionWizard';
import withNewProjectWizard from 'DesignFinderUI/components/modals/hoc/withNewProjectWizard';
import withDeployFunctionWizard from 'DesignFinderUI/components/modals/hoc/withDeployFunctionWizard';
import withDeployProjectWizard from 'DesignFinderUI/components/modals/hoc/withDeployProjectWizard';
const DraggableNavItemLink = Draggable(FolderNavItemLink);

class FolderTitle extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      isContextMenuOpen: false,
      showRenameConfirmModal: false,
      renameValue: null,
      contextMenuInitialized: false
    };

    this.handleRenameSubmit = renameValue => {
      const {
        isRenamingDuplicate,
        onRenameConfirm,
        showRenameConfirm
      } = this.props;

      if (isRenamingDuplicate || !showRenameConfirm) {
        onRenameConfirm(renameValue);
      } else {
        this.onRenameSubmit(renameValue);
      }
    };

    this.handleContextMenuOpenChange = isContextMenuOpen => {
      this.setState({
        isContextMenuOpen
      });
    };

    this.onRenameSubmit = renameValue => {
      this.setState({
        showRenameConfirmModal: true,
        renameValue
      });
    };

    this.handleRenameCallback = () => {
      this.setState({
        showRenameConfirmModal: false,
        renameValue: null
      });
    };

    this.initializeContextMenu = () => {
      if (this.props.isRootFolder && !this.props.isThemeFolder) {
        return;
      }

      this.setState({
        contextMenuInitialized: true
      });
    };
  }

  renderRenameConfirmModal() {
    return /*#__PURE__*/_jsx(RenameFolderConfirmModal, {
      callback: this.handleRenameCallback,
      folderId: this.props.folderId,
      newFolderName: this.state.renameValue
    }, "RenameFolderConfirmModal");
  }

  render() {
    const {
      NewFileWizard,
      NewThemeWizard,
      NewFunctionWizard,
      NewProjectWizard,
      DeployFunctionWizard,
      DeployProjectWizard,
      _connectDragSource: connectDragSource,
      className,
      folderName,
      folderPermissions,
      isRenamingFolder
    } = this.props;
    const {
      isContextMenuOpen,
      showRenameConfirmModal,
      contextMenuInitialized
    } = this.state;
    const {
      [FINDER_FOLDER_RENAME]: canRenameFolder
    } = folderPermissions;
    const renameConfirmModal = showRenameConfirmModal ? this.renderRenameConfirmModal() : null;
    const folderClasses = classNames('folder-item-link', className, isContextMenuOpen && 'is--context-menu-open');

    let folderTitleNavLink = /*#__PURE__*/_jsx(DraggableNavItemLink, Object.assign({}, this.props, {
      canRename: canRenameFolder,
      className: folderClasses,
      connectDragSource: connectDragSource,
      isRenameActive: isRenamingFolder,
      isRenameConfirmPending: showRenameConfirmModal,
      name: folderName,
      onFocus: this.initializeContextMenu,
      onMouseEnter: this.initializeContextMenu,
      linkComponent: "div",
      onRenameSubmit: this.handleRenameSubmit
    }));

    if (contextMenuInitialized) {
      folderTitleNavLink = /*#__PURE__*/_jsx(AssetContextMenu, Object.assign({}, omit(this.props, ['className']), {
        onOpenChange: this.handleContextMenuOpenChange,
        children: folderTitleNavLink
      }));
    }

    return /*#__PURE__*/_jsxs(Fragment, {
      children: [folderTitleNavLink, NewFileWizard, NewThemeWizard, NewFunctionWizard, NewProjectWizard, DeployFunctionWizard, DeployProjectWizard, renameConfirmModal]
    });
  }

}

FolderTitle.propTypes = {
  NewFileWizard: PropTypes.node,
  NewThemeWizard: PropTypes.node,
  NewFunctionWizard: PropTypes.node,
  NewProjectWizard: PropTypes.node,
  DeployFunctionWizard: PropTypes.node,
  DeployProjectWizard: PropTypes.node,
  _connectDragSource: PropTypes.func.isRequired,
  className: PropTypes.string,
  folderId: FolderPropTypes.folderId.isRequired,
  folderName: FolderPropTypes.folderName.isRequired,
  folderPermissions: FolderPropTypes.folderPermissions.isRequired,
  isRenameConfirmPending: PropTypes.bool,
  isRenamingDuplicate: PropTypes.bool.isRequired,
  isRenamingFolder: FolderPropTypes.isRenamingFolder.isRequired,
  isRootFolder: PropTypes.bool.isRequired,
  isThemeFolder: PropTypes.bool.isRequired,
  isUserFolder: FolderPropTypes.isUserFolder,
  onDeleteFolderClick: PropTypes.func,
  onDragOverOpenChange: PropTypes.func,
  onNewFileClick: PropTypes.func,
  onNewThemeClick: PropTypes.func,
  onNewFunctionClick: PropTypes.func,
  onDeployFunctionClick: PropTypes.func,
  onDeployProjectClick: PropTypes.func,
  onRenameConfirm: PropTypes.func.isRequired,
  showRenameConfirm: PropTypes.bool.isRequired
};
FolderTitle.defaultProps = {
  NewFileWizard: null,
  NewThemeWizard: null,
  NewFunctionWizard: null,
  NewProjectWizard: null,
  DeployFunctionWizard: null,
  DeployProjectWizard: null,
  className: '',
  isRenameConfirmPending: false,
  onDeleteFolderClick: emptyFunction,
  onDragOverOpenChange: emptyFunction,
  onNewFileClick: emptyFunction,
  onNewThemeClick: emptyFunction,
  onNewFunctionClick: emptyFunction,
  onDeployFunctionClick: emptyFunction
};
export default compose(withNewFileWizard, withNewThemeWizard, withNewFunctionWizard, withNewProjectWizard, withDeployFunctionWizard, withDeployProjectWizard)(FolderTitle);